import { MmBUtilService } from "@src/components/services/Utils/ib-MmB-utils";

@Service(
    'ib-MmB-communication-lost-module',
    ['MmBUtilService'],
    []
)
export class MmBCommunicationLostTransformer {
    constructor (
        private mmBUtilService: MmBUtilService
    ) { }

    /**
    * generates the communication lost info calling to transformer
    */
    generateCommunicationLostInfo = (confirmationInfo, creditCardTypes) => {
        const communicationLostModel = {
            communicationLostInfo: this.mmBUtilService.getCommunicationsLostInfo(confirmationInfo, creditCardTypes),
            relatedContent: this.mmBUtilService.getRelatedContent(confirmationInfo && confirmationInfo.relatedContent ? confirmationInfo.relatedContent : null)
        };
        return communicationLostModel;
    }
}
